  const bg = document.getElementById("parallax-bg");
  window.addEventListener("scroll", () => {
    const yPos = window.scrollY * 0.5;
    bg.style.transform = `translateY(${yPos}px)`;
  }, { passive: true });